import { FC } from "react";

import { Flex } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";

import responsiveStyle from "@lib/theme/responsiveStyle";

import type { TTotalCountProps } from "../types";

const TotalCount: FC<TTotalCountProps> = ({ count }) => {
  const { t } = useTranslation();
  return (
    <Flex align="center" fontSize={responsiveStyle({ mobile: "0.875rem", desktop: "1rem" })}>
      {t("common-pagination-total_count", { count })}
    </Flex>
  );
};
export default TotalCount;
